import React from 'react';
import Wrapper from 'src/constrains/SalesChannelContentWrapperRevamp';
import { Menu, MenuItem } from '@/src/components/Antd';
import { Dropdown } from 'antd';
import { useSalesChannelContentPage } from 'src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage-revamp/hooks/useSalesChannelContentPages';
import { get } from 'lodash';
import ContentReverseIcon from 'src/constrains/ContentReverseIcon';
import { EnumPageType } from 'src/types/common';
import ContentGrid from '@/src/components/SalesChannelComponents/SalesChannelContentGrid';
import ConfigContainer from '@/src/components/SalesChannelComponents/SalesChannelConfigContainer';
import ClickableConfigItem from 'src/components/SalesChannelComponents/ClickableConfigItem';
import { contentRender } from './contentRender';
import {
  seoSetting,
  pageSetting,
} from 'src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage-revamp/constants';
import ModulesList from 'src/constrains/SalesChannelContent-Revamp/ModulesList';
import { useSelector } from 'react-redux';
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { ContentModuleGroupPreloadingWrapper } from '@/src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import { useParams } from 'react-router-dom';
import { Button } from '@/src/components/Antd';
import ChangesMonitor from 'src/constrains/SalesChannelContent-Revamp/HomePageChangesMonitor';
import SeoErr from 'src/components/Modules-revamp/SlugSeoSetting/ErrorDisplay';
import PageErr from 'src/components/Modules-revamp/PageSettings/ErrorDisplay';
import { InfoCircleOutlined } from '@ant-design/icons';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, getI18nFromGeneral } from 'src/tools/tools';
import RouteBlock from 'src/constrains/RouterBlock/RouterBlock';
import { Icon } from '@/src/tools/icon';

const ContentPage = () => {
  const {
    pcForm,
    mobileForm,
    tabletForm,
    seoSettingForm,
    orderForm,
    salesChannel,
    dataLoading,
    data,
    selectedLanguage,
    selectedItem,
    handleOnSelect,
    handleOnAdd,
    handleOnDuplicate,
    moduleData,
    handleOnSubmit,
    handleOnPreview,
    handleOnDelete,
    handlePCFormValuesChange,
    handleCloneFromPrimaryLanguage,
    handleOnSectionReset,
    handleOnSectionCopy,
    handleOnDiscard,
    onGoBack,
    hasModified,
    setHasModified,
    loaded,
    pageSettingForm,
    seoSettingData,
    pageSettingData,
    handleOnRouteChange,
    salesChannelMode,
  } = useSalesChannelContentPage();
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const { status, timezoneInGmt, uuid } = data || {};
  const isOnPrimaryLanguage = useSelector(isPrimaryLanguage());
  const _params: any = useParams();
  const { contentUuid, saleChannelUuid } = _params;
  // const saleChannelUuid = get(salesChannel, 'uuid');
  const headerProps = {
    title: get(salesChannel, 'name'),
    description: get(data, 'salesChannelContent.versionName'),
    status: get(data, 'salesChannelContent.status'),
    hasModified,
    onSubmit: handleOnSubmit,
    onDiscard: handleOnDiscard,
    onGoBack,
    rarePart: !dataLoading ? (
      <Dropdown.Button
        className={css.dropdownButton}
        icon={<Icon type='icondown' className={css.icon} />}
        getPopupContainer={() => document.body}
        overlay={
          <Menu>
            <MenuItem>
              <ContentReverseIcon
                onlyText
                salesChannelUuid={saleChannelUuid}
                entityUuid={get(data, 'uuid')}
                locale={selectedLanguage}
                entityType={EnumPageType.ContentHomePage}
                onReload={({ qParams }) => {
                  return;
                }}
              />
            </MenuItem>
            <MenuItem onClick={handleOnPreview}>
              {getI18n('salesChannelContent.homePage.previewChange')}
            </MenuItem>
          </Menu>
        }>
        <div className={css.dropdownLeft}>
          {getI18nFromGeneral('general.action.moreAction')}
        </div>
      </Dropdown.Button>
    ) : (
      <React.Fragment />
    ),
  };
  const displayProps = {
    pcForm,
    mobileForm,
    tabletForm,
    selectedItem,
    moduleData,
  };
  return (
    <ContentModuleGroupPreloadingWrapper
      saleChannelUuid={saleChannelUuid}
      contentUuid={contentUuid}>
      <ChangesMonitor
        loaded={loaded}
        setHasModified={setHasModified}
        pcForm={pcForm}
        tabletForm={tabletForm}
        mobileForm={mobileForm}
        seoForm={seoSettingForm}
        orderForm={orderForm}
        pageSettingForm={pageSettingForm}
      />
      <RouteBlock
        onConfirm={(f) => {
          handleOnRouteChange();
          if (f) {
            f();
          }
        }}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.discard_content')}
      />
      {dataLoading ? null : (
        <Wrapper headerProps={headerProps}>
          <ContentGrid
            configCols={contentRender({
              pcForm,
              mobileForm,
              tabletForm,
              seoSettingForm,
              pageSettingForm,
              selectedItem,
              handlePCFormValuesChange,
              handleOnSectionReset,
              handleOnSectionCopy,
              pageSettingConfigData: { status, timezoneInGmt },
              seoSettingConfigData: { contentUuid, uuid },
              isOnPrimaryLanguage,
              salesChannelMode,
            })}
            mainCol={
              <ConfigContainer
                offset={isOnPrimaryLanguage ? 250 : 315}
                top={
                  <>
                    {!isOnPrimaryLanguage && (
                      <Button
                        block
                        type={'primary'}
                        size={'large'}
                        style={{
                          marginBottom: '9px',
                          textAlign: 'left',
                          padding: '10px 12px',
                          height: '56px',
                          fontWeight: 'bold',
                        }}
                        onClick={handleCloneFromPrimaryLanguage}>
                        {'Clone from Primary Language'}
                      </Button>
                    )}
                    <ClickableConfigItem
                      Error={
                        <SeoErr
                          form={seoSettingForm}
                          selected={selectedItem === seoSetting}
                          data={seoSettingData}
                        />
                      }
                      content={'Page Seo Setting'}
                      onClick={() => {
                        handleOnSelect(seoSetting);
                      }}
                    />
                    <ClickableConfigItem
                      //PageErr
                      Error={
                        <PageErr
                          form={pageSettingForm}
                          selected={selectedItem === pageSetting}
                          data={pageSettingData}
                        />
                      }
                      content={'Page Settings'}
                      onClick={() => {
                        handleOnSelect(pageSetting);
                      }}
                    />
                  </>
                }
                bottom={
                  <React.Fragment>
                    <div className={css.titleContainer}>
                      <InfoCircleOutlined rev className={css.icon} />
                      <div>{getI18n('general.dragmodule')}</div>
                    </div>
                    <ModulesList
                      form={orderForm}
                      onClick={handleOnSelect}
                      onDelete={handleOnDelete}
                      onAdd={handleOnAdd}
                      onDuplicate={handleOnDuplicate}
                      //
                      errorDisplay={displayProps}
                      visibleDisplay={displayProps}
                      selectedItem={selectedItem}
                    />
                  </React.Fragment>
                }
              />
            }
          />
        </Wrapper>
      )}
    </ContentModuleGroupPreloadingWrapper>
  );
};
export default ContentPage;
